import { gql } from "gql";

export const SAVE_BPM_ROLE_ASSIGNMENT = gql(`
  mutation SaveHrRoleAssignment ($assignment: HrRoleAssignmentInput!) {
    saveHrRoleAssignment(assignment: $assignment)
  }
`);
